import RenderManager from '../rendering/render-manager';

function updateTonemapping() {
    const target = {
        //r: RenderManager.activeScene.background.r,
        //g: RenderManager.activeScene.background.g,
        //b: RenderManager.activeScene.background.b,
        toneMappingExposure: RenderManager.toneMappingExposure,
        onUpdate() {

            RenderManager.toneMappingExposure = tween.toneMappingExposure;
            //RenderManager.activeScene.background.setRGB( tween.r, tween.g, tween.b );

            RenderManager.activeCamera.update = true;

        }
    };

    RenderManager.toneMappingExposure = 0;
    //RenderManager.activeScene.background.setRGB( 0, 0, 0 );

    const tween = { r: 0, g: 0, b: 0, toneMappingExposure: 0 };

    TweenMax.to(tween, 1, target);
}

export default updateTonemapping;
export { updateTonemapping };